/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EquipmentSubModelResponse { 
    id: string;
    name?: string | null;
    nominalHashrate?: number | null;
    isAutoDetected?: boolean;
    source?: string | null;
    detectedVia?: string | null;
    detectedAt?: string | null;
}

